module.exports = __webpack_public_path__ + "media/images/banks/maybank-614e2542a5ec764eb5382df64a230181.png";